import $ from 'jquery';
import Cookies from 'js-cookie';

const $popup = $('#popup-newsletter');
const $closeButton = $('#popup-close');

if ($popup.length && $closeButton.length) {
  const popupClosed = Cookies.get('popup_closed');

  if (!popupClosed) {
    setTimeout(() => {
      $popup.css('display', 'flex');
    }, 30000);
  }

  $closeButton.on('click', () => {
    $popup.css('display', 'none');
    Cookies.set('popup_closed', 'true', { expires: 3 });
  });
}
